// eslint-disable-next-line import/prefer-default-export
export const formValidation = {
  methods: {
    validate() {
      Object.keys(this.$refs).forEach(ref => this.$refs[`${ref}`].validate(true));
    },
  },
};
